/* Mint-Settle-iPad (1180): người dạng thẻ 2 cột | Đối soát kỳ. Màu chỉ var(--…). */
.page { gap: 12px; }
.cols { gap: 12px; }
.cards { flex: 1; min-width: 0; display: grid; grid-template-columns: 1fr 1fr; gap: 10px; align-content: start; padding-bottom: 88px; }
.card { display: flex; flex-direction: column; gap: 10px; padding: 14px 16px; box-sizing: border-box; border: 0; border-radius: 16px; background: var(--card); box-shadow: var(--sh); color: var(--tx); font: inherit; font-size: 15px; text-align: left; cursor: pointer; }
.card:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.top { display: flex; align-items: center; gap: 10px; width: 100%; }
.ttl { flex-grow: 1; min-width: 0; }
.ttl b { display: flex; align-items: center; gap: 6px; font-weight: var(--fw-label); }
.ttl > span { display: block; font-size: 13px; color: var(--lb); }
.lock { width: 32px; height: 28px; flex-shrink: 0; border-radius: 8px; display: flex; align-items: center; justify-content: center; background: var(--err-bg); color: var(--err); }
.stats { display: grid; grid-template-columns: repeat(4, auto); justify-content: space-between; gap: 8px; width: 100%; }
.stats > span > span { display: block; font-size: 13px; color: var(--lb); }
.stats > span > b { display: block; font-size: 15px; font-weight: var(--fw-label); }
.rec { width: 300px; }
/* page=detail: trang chi tiết người (không dùng ngăn) */
.dHead { display: flex; align-items: center; gap: 10px; }
.dTtl { min-width: 0; }
.dTtl b { display: block; font-size: 22px; font-weight: 600; }
.dTtl > span { display: block; font-size: 13px; color: var(--lb); }
.dCard { display: flex; flex-direction: column; border-radius: 16px; background: var(--card); box-shadow: var(--sh); }
.dBody { padding: 12px 16px; }
.dBody > div:first-of-type { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.dFoot { display: flex; align-items: center; gap: 8px; padding: 12px 16px; border-top: 1px solid var(--line); }
